import {alias, createModelSchema, reference} from "serializr";

import {TriggerBase} from "./core/TriggerBase";
import {TriggerKind} from "./core/TriggerKind";
import {TriggerScope} from "./core/TriggerScope";
import {ShipKind} from "@/modules/redactor/models/trader/ShipKind";


export class TriggerShip extends TriggerBase {

    constructor() {
        super(TriggerKind.SHIP);

        this._trader = ShipKind.NONE;
    }

    get trader() {
        return this._trader;
    }

    set trader(value) {
        this._trader = value;
    }

    valid() {

        if (!super.valid()) {
            return false;
        }

        if (!ShipKind.is(this.trader) || ShipKind.NONE.equal(this.trader)) {
            return false;
        }

        return true;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new TriggerShip());
        } else if (target instanceof TriggerShip) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }

}

export class TriggerShipScope extends TriggerScope {
    static _values = [
        new TriggerShipScope(2, "CARGO_AVAILABLE"),
        new TriggerShipScope(3, "CARGO_UNAVAILABLE"),
        new TriggerShipScope(4, "REWARD_AVAILABLE"),
        new TriggerShipScope(5, "REWARD_UNAVAILABLE")
    ];

    static getValues() {
        return this._values;
    }

    static getValue(id) {
        let value = this._values.find(v => v.id === id) || null;
        console.assert(value, "unknown id: " + id);
        return value;
    }

    static schema() {
        return reference("id", (id, cb) => {
            return cb(null, TriggerShipScope.getValue(id));
        });
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new TriggerShipScope());
        } else if (target instanceof TriggerShipScope) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(TriggerShip, {
    _scope: alias("scope", TriggerShipScope.schema()),
    _trader: alias("trader", ShipKind.schema())
});
